// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/chart-distance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/chart-distance/chart-distance.js';

mount([g0]);
